// Updated ProjetsMatchesDashboard with mobile dropdown tabs
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMatches, fetchMessages, selectMatch } from "../../redux/actions/matchActions";
import ProjectCard from "../ProjectCard";
import ChatConversation from "../ChatConversation";
import FormModalPropositionCommerciale from "../FormModalPropositionCommerciale";
import useWebSocket from "../../hooks/useWebSocket";
import VisioTab from "../VisioTab";
import { useGlobalCall } from "../../hooks/useGlobalCall";
import { setActiveTabMatch } from "../../redux/actions/dashboardActions";
import ImportDocumentModal from "../ImportDocumentModal";

const ProjetsMatchesDashboard = () => {
    const dispatch = useDispatch();
    const { list, selectedMatch } = useSelector((state) => state.match);
    const { token, user } = useSelector((state) => state.auth);
    const { activeTabMatch } = useSelector((state) => state.dashboard);
    const usersOnline = useSelector((state) => state.online.usersOnline);
    const globalCallRef = useGlobalCall();

    const [showDevisModal, setShowDevisModal] = useState(false);
    const [typeDocument, setTypeDocument] = useState("");
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const wsRef = useRef(null);
    const { sendTypingStatus, addCallListener } = useWebSocket(wsRef);

    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

    useEffect(() => {
        if (token) dispatch(fetchMatches(token));
    }, [dispatch, token]);
    useEffect(() => {
        if (activeTabMatch === "") {
            dispatch(setActiveTabMatch("projet"));
        }
    }, dispatch, activeTabMatch)

    const containerStyle = { padding: "20px", display: "flex", flexDirection: "column", gap: "15px" };
    const listCard = { display: "flex", flexDirection: "column", alignItems: "center", padding: "15px", border: "1px solid #ddd", borderRadius: "10px", background: "#fff", cursor: "pointer" };
    const listCardHover = { borderColor: "#007bff", boxShadow: "0 4px 12px rgba(0,0,0,0.12)" };

    const badge = (online) => ({
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: online ? "#d4f8d4" : "#f0f0f0",
        color: online ? "#258f25" : "#555",
        border: `1px solid ${online ? "#42c442" : "#aaa"}`,
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "13px",
        marginLeft: "10px",
    });

    const wonBadge = {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "#e6f7ff",
        color: "#0056b3",
        border: "1px solid #3399ff",
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "13px",
        fontWeight: "600",
        marginBottom: "6px",
    };


    const tabList = [
        { id: "projet", label: "📁 Projet" },
        { id: "chat", label: "💬 Conversation" },
        { id: "devis", label: "Devis et facture" },
    ];

    if (!selectedMatch) {
        return (
            <div style={containerStyle}>
                <h2 style={{ textAlign: "center" }}>Mes Projets Matchés</h2>
                {list.length === 0 && <p>Aucun projet matché pour le moment.</p>}

                {list.map((match) => {
                    if(match.projet?.statusProjetClient === "realised" || match.projet?.statusProjetClient === "canceled"){
                        return;
                    }
                    const isOnline = usersOnline[match.client?.idUser] === true;

                    return (
                        <div
                            key={match.id}
                            style={listCard}
                            onClick={() => dispatch(selectMatch(match))}
                            onMouseEnter={(e) => Object.assign(e.currentTarget.style, listCardHover)}
                            onMouseLeave={(e) => Object.assign(e.currentTarget.style, listCard)}
                        >
                            {match.projet?.selectedPresta?.idPrestataire === user.profilPrestataire.idPrestataire && (
                                <span style={wonBadge}>🏆 Projet remporté</span>
                            )}
                            <span style={badge(isOnline)}>{isOnline ? "En ligne" : "Hors ligne"}</span>
                            
                            <h3>{match.projet?.titreProjetClient}</h3>
                            <p style={{ opacity: 0.7 }}>{match.client?.raisonSocialeClient}</p>
                        </div>
                    );
                })}
            </div>
        );
    }

    const isPrestataire = user.rolesUser[0].roleUser === "prestataire";
    const toUserId = isPrestataire ? selectedMatch.client.idUser : selectedMatch.prestataire.idUser;
    const isOnline = usersOnline[toUserId] === true;

    const handleCall = () => {
        window.dispatchEvent(
            new CustomEvent("setCallInfo", {
                detail: { fromUserId: user.idUser, toUserId: toUserId, matchId: selectedMatch.id },
            })
        );
        globalCallRef.current?.();
    };

    return (
        <div style={containerStyle}>
            <button
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#f5f5f5",
                    border: "1px solid #d4d4d4",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#333",
                }}
                onClick={() => dispatch(selectMatch(null))}
            >
                <span style={{ fontSize: "18px" }}>←</span> Retour aux projets
            </button>

            <div style={{ border: "1px solid #ccc", borderRadius: "10px", padding: "25px", background: "#fff" }}>
                <h2>{selectedMatch.projet.titreProjetClient}</h2>
                {selectedMatch.projet?.selectedPresta?.idPrestataire === user.profilPrestataire.idPrestataire && (
                    <span style={wonBadge}>🏆 Projet remporté</span>
                )}
                <span style={badge(isOnline)}>{isOnline ? "En ligne" : "Hors ligne"}</span>
                
                {/* Desktop Tabs */}
                {!isMobile && (
                    <div style={{ display: "flex", gap: "12px", marginTop: "20px", marginBottom: "15px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab.id}
                                style={{
                                    padding: "8px 14px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                    background: activeTabMatch === tab.id ? "#007bff" : "#f1f1f1",
                                    color: activeTabMatch === tab.id ? "white" : "#333",
                                    border: "none",
                                }}
                                onClick={() => dispatch(setActiveTabMatch(tab.id))}
                            >
                                {tab.label}
                            </button>
                        ))}

                        {/* {isOnline && <button onClick={handleCall}>📞 Appel vidéo</button>} */}
                    </div>
                )}

                {/* Mobile Dropdown */}
                {isMobile && (
                    <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                        <button
                            style={{ padding: "10px", borderRadius: "6px", background: "#f1f1f1", width: "100%" }}
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {tabList.find((t) => t.id === activeTabMatch)?.label} ▾
                        </button>
                        {mobileMenuOpen && (
                            <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "6px", background: "#fafafa" }}>
                                {tabList.map((tab) => (
                                    <div
                                        key={tab.id}
                                        style={{ padding: "12px", cursor: "pointer" }}
                                        onClick={() => {
                                            dispatch(setActiveTabMatch(tab.id));
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        {tab.label}
                                    </div>
                                ))}

                                {/* {isOnline && (
                                    <div style={{ padding: "12px", cursor: "pointer" }} onClick={handleCall}>
                                        📞 Appel vidéo
                                    </div>
                                )} */}
                            </div>
                        )}
                    </div>
                )}

                {activeTabMatch === "projet" && (
                    <ProjectCard
                        project={selectedMatch.projet}
                        idUserClient={selectedMatch.client.idUser}
                        onLike={null}
                        onPass={null}
                        isReceivedLike={false}
                        isAlreadyMatched={true}
                    />
                )}

                {activeTabMatch === "chat" && (
                    <ChatConversation toUserId={toUserId} onMessageSent={() => dispatch(fetchMessages(token, selectedMatch.id))} />
                )}

                {activeTabMatch === "devis" && (
                    <>
                        <h3>Vos Devis et factures envoyés</h3>
                        <button onClick={() => {setShowDevisModal(true);setTypeDocument("devis")}} style={{ marginTop: "12px" }}>
                            ➕ Importer un nouveau devis
                        </button>
                        {
                            selectedMatch.projet?.selectedPresta?.idPrestataire === user.profilPrestataire.idPrestataire && (
                                <button onClick={() => {setShowDevisModal(true);setTypeDocument("facture")}} style={{ marginTop: "12px" }}>
                            ➕ Importer une nouvelle facture
                        </button>
                            )
                        }
                        {showDevisModal && (
                            <ImportDocumentModal
                                idMatch={selectedMatch.id}
                                typeClient="client"
                                typeDocument={typeDocument}
                                onClose={() => setShowDevisModal(false)}
                                onSuccess={() => setShowDevisModal(false)}
                                token={token}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ProjetsMatchesDashboard;
